import { NotFoundBody } from '@framework/ui/components/alert/NotFoundBody.tsx';
import type * as React from 'react';
import {
  AlertPageLayout,
  type IAlertPageLayoutProps,
} from '../components/AlertPageLayout.tsx';

export interface INotFoundPageProps
  extends Omit<IAlertPageLayoutProps, 'children'> {
  message?: React.ReactNode;
  description?: React.ReactNode;
}

export function NotFoundPage(props: INotFoundPageProps) {
  const { message, description, ...rest } = props;
  return (
    <AlertPageLayout {...rest}>
      <NotFoundBody message={message} description={description} />
    </AlertPageLayout>
  );
}
